import React, { createContext, useState, useEffect, useContext } from 'react';

const QuestionnaireContext = createContext();

export const useQuestionnaire = () => useContext(QuestionnaireContext);

const LOCAL_STORAGE_KEY = 'questionnaireAnswers';

export const QuestionnaireProvider = ({ children }) => {
    const [answers, setAnswers] = useState(() => {
        // Load answers from localStorage on initial load
        const savedAnswers = localStorage.getItem(LOCAL_STORAGE_KEY);
        return savedAnswers ? JSON.parse(savedAnswers) : {};
    });

    // Save answers to localStorage whenever they change
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(answers));
    }, [answers]);

    const updateAnswer = (stepKey, data) => {
        setAnswers(prevAnswers => ({
            ...prevAnswers,
            [stepKey]: data,
        }));
    };

    const getAnswer = (stepKey) => {
        return answers[stepKey];
    };

    const getAllAnswers = () => {
        return answers;
    };

    const clearAllAnswers = () => {
        setAnswers({});
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    };

    const loadAnswersFromJSON = (jsonData) => {
        // Directly set the answers state with the provided JSON data
        // The useEffect hook will then automatically update localStorage
        setAnswers(jsonData);
    };

    return (
        <QuestionnaireContext.Provider value={{ updateAnswer, getAnswer, getAllAnswers, clearAllAnswers, loadAnswersFromJSON, answers }}>
            {children}
        </QuestionnaireContext.Provider>
    );
};

export default QuestionnaireContext;